/**
 * Reads a table of known keys with a key that only arrives as a string (a
 * route name, a slug, a stored enum value). Returns `undefined` when the key
 * is not one of the table's own properties, so every caller spells out its
 * fallback instead of trusting an index signature.
 */
export function lookup<T extends object>(
  table: T,
  key: string,
): T[keyof T] | undefined {
  if (!Object.prototype.hasOwnProperty.call(table, key)) {
    return undefined;
  }
  // SAFETY: hasOwnProperty proved `key` names one of `table`'s own properties.
  return table[key as keyof T];
}
